import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateTeacherProfessionalInfoBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const updateTeacherProfessionalInfo = createAsyncThunk<void, UpdateTeacherProfessionalInfoBody, { extra: Partial<Dependencies> }>(
  "teachers/updateTeacherProfessionalInfo",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.updateProfessionalInfo(body);
  },
);

export const resetUpdateTeacherProfessionalInfo = createAction("teachers/resetUpdateTeacherProfessionalInfo");
